import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonSelectorComponent } from '@ui/button-selector/button-selector.component';

@NgModule({
    declarations: [ButtonSelectorComponent],
    imports: [CommonModule, TranslateModule],
    exports: [ButtonSelectorComponent],
})
export class ButtonSelectorModule {}
